import { ORDER_ITEM_DETAIL, ORDER_ITEM_LIST } from './itemTypes'

export default {
    [ORDER_ITEM_LIST](state, data) {
        state.itemList = data;
    },

    [ORDER_ITEM_DETAIL](state, data) {
        state.itemDetail = data;
    }
}
